import type { ProductionRun } from "./models";
import { operationalShiftAt } from "../../../shared/production/plan-window";

export function operatorDayRuns(runs: ProductionRun[], lineId: string | null, date: string) {
  return runs.filter(run => {
    if (run.lineId !== lineId || run.disposition === "CANCELLED") return false;
    if (run.status === "ACTIVE") return true;
    if (run.status !== "COMPLETED") return false;
    const closed = Date.parse(run.closedAt ?? "");
    return (Number.isFinite(closed) ? operationalShiftAt(closed).date : run.shiftDate) === date;
  });
}
